import React from 'react';
import PropTypes from 'prop-types';
import uniq from 'lodash.uniq';

import { Checkbox, Button } from '../../../../components';

const QuestionnaireFilter = ({ questionnaireOptions = [], selectedQuestionnaires = [], onSelectedQuestionnairesChanged }) => {
	const handleToggleSingleSelection = ({ target }) => {
		const careQuestGroupId = parseInt(target.value, 10);
		let updatedSelections = selectedQuestionnaires.slice();
		if (target.checked) {
			updatedSelections.push(careQuestGroupId);
		} else {
			updatedSelections = updatedSelections.filter(cqgid => cqgid !== careQuestGroupId);
		}
		onSelectedQuestionnairesChanged(uniq(updatedSelections));
	};

	return (
		<div className="panel panel-primary q-filter">
			<div className="panel-heading">Questionnaire Filter</div>
			<div className="panel-body">
				<div>
					<Button
						title="Clear All"
						onClick={() => onSelectedQuestionnairesChanged([])}
						info
						small
					/>
				</div>
				<div className="questionnaires">
					{questionnaireOptions.sort((a, b) => (a.name > b.name) ? 1 : -1).map(qo => (
						<Checkbox
							key={`${qo.care_quest_group_id}`}
							label={qo.name}
							checked={selectedQuestionnaires.includes(qo.care_quest_group_id)}
							onChange={handleToggleSingleSelection}
							value={qo.care_quest_group_id}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

QuestionnaireFilter.propTypes = {
	questionnaireOptions: PropTypes.array,
	selectedQuestionnaires: PropTypes.array,
	onSelectedQuestionnairesChanged: PropTypes.func.isRequired
};

export default QuestionnaireFilter;
